export default "__VITE_ASSET__BMeQoSEx__"